import { FiveLLQuadRenderer, FiveLLQuadNode } from "@dino/shared"
import React from "react"
import { useParams } from "react-router-dom"
import { useDinoPaperQuery } from "../../../generated-types"
import { ResultLayout } from "./ResultLayout"

export const FiveLLQuadResult = () => {
  const { paperId } = useParams()
  const { data } = useDinoPaperQuery({ variables: { paperId } })

  return (
    <ResultLayout>
      {({ width, refStage }) => (
        <FiveLLQuadRenderer width={width} ref={refStage}>
          {data?.dinoPaper?.results && <FiveLLQuadNode value={data.dinoPaper.results} />}
        </FiveLLQuadRenderer>
      )}
    </ResultLayout>
  )
}
